import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

export interface ViewerImage {
  url: string;
  caption: string;
}

@Component({
  templateUrl: 'image-viewer.component.html',
  styleUrls: ['image-viewer.component.scss']
})
export class ImageViewerComponent {
  @Input() image: ViewerImage;

  constructor(private modalCtrl: ModalController) {}

  close() {
    this.modalCtrl.dismiss();
  }
}
